import * as React from 'react';

import { ViewExtraLarge, Viewport } from 'bernie-view';

import { DisplayAd } from 'constants/ads';
import { MesoDisplayAd } from './meso-display-ad';
import { MesoTrigger } from './meso-trigger';

interface MesoSideRailProps {
  pageName: string;
}

export class MesoSideRail extends React.Component<MesoSideRailProps> {
  public render() {
    const { pageName } = this.props;

    return (
      <Viewport>
        <ViewExtraLarge>
          <React.Fragment>
            <MesoDisplayAd {...DisplayAd.SIDERAIL_XL_R1} />
            <MesoDisplayAd {...DisplayAd.SIDERAIL_XL_RM} />
            <MesoDisplayAd {...DisplayAd.SIDERAIL_XL_R2} />
            <MesoTrigger pageName={pageName} />
          </React.Fragment>
        </ViewExtraLarge>
      </Viewport>
    );
  }
}
